import { v4 as uuidv4 } from "uuid";
import { globalStore } from "../globalStore";
import { photoshop, uxp } from "../globals";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";

export const loadPsd = async (endpoint: string, fileName: string) => {
	try {
		await photoshop.core.executeAsModal(
			async () => {
				const psdUrl = `${globalStore.getState().proxyUrl}/${endpoint}`;

				const response = await fetch(psdUrl);
				console.log(response);
				if (!response.ok) throw new Error(`HTTP ${response.status}`);
				const arrayBuffer = await response.arrayBuffer();

				const tempFolder =
					await uxp.storage.localFileSystem.getTemporaryFolder();

				const tempFile = await tempFolder.createFile(
					`${fileName}-${Date.now()}.psd`,
					{
						overwrite: true,
					},
				);
				await tempFile.write(arrayBuffer, {
					format: uxp.storage.formats.binary,
				});
				await photoshop.app.open(tempFile);
				const activeDocument = photoshop.app.activeDocument;
				postToRenderer([
					{
						key: "documentInfoChanged",
						id: uuidv4(),
						values: {
							width: activeDocument?.width || 0,
							height: activeDocument?.height || 0,
						},
					},
				]);
			},
			{ commandName: "Open PSD" },
		);
	} catch (err) {
		await photoshop.app.showAlert(`failed to open psd: ${err}`);
	}
};

export function useListenOpenPsdMessage() {
	useListenFromRenderer([
		{
			key: "openPsd",
			onMessage: (message) => {
				const { endpoint, fileName } = message.values;
				loadPsd(endpoint, fileName);
			},
		},
	]);
}
